import React from "react"
import { createStore } from "core/store"

const { useStore: useHoverNode, set: setHoverNode } = createStore(null)

function SlateNode({ as = "div", children, node, ...props }) {
  const Component = as
  const hoverNode = useHoverNode()

  const handleMouseEnter = () => {
    if (hoverNode?.key !== node.key) setHoverNode(node)
  }

  return (
    <Component onMouseEnter={handleMouseEnter} {...props}>
      {children}
    </Component>
  )
}

export { useHoverNode, setHoverNode }
export default SlateNode
